import * as Yup from 'yup';

export const nameAndImage = Yup.object({
  name: Yup.string().required(),
  imageId: Yup.string().optional(),
});
